var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"toggle-switch",class:{
        'disabled': _vm.readonly,
        'no-label': !_vm.hasLabels,
        'reverse-positioning': _vm.labelPositionFlip
    }},[(_vm.hasLabels)?_c('span',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.value ? _vm.labelOn : _vm.labelOff)+" ")]):_vm._e(),_c('div',{staticClass:"toggle"},[_c('input',{staticClass:"visually-hidden",class:{ 'checked': _vm.value },attrs:{"type":"checkbox","disabled":_vm.readonly},domProps:{"value":_vm.value},on:{"change":_vm.toggle}}),_c('span',{staticClass:"slider"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }